import { HeartFilled } from '@ori-ui/icons';
import { useEffect, useRef } from 'react';
import { HeartRoot } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
var SPREAD_FACTOR = 30;
var FONT_SCALE = 5;
export var Heart = function Heart(_ref) {
  var angle = _ref.angle,
    index = _ref.index;
  var element = useRef(null);
  var x = Math.cos(angle) * SPREAD_FACTOR;
  var y = Math.sin(angle) * SPREAD_FACTOR;
  var spreadX = Math.floor(Math.random() * SPREAD_FACTOR) + (x - SPREAD_FACTOR / 2);
  var spreadY = Math.floor(Math.random() * SPREAD_FACTOR) + (y - SPREAD_FACTOR / 2);
  useEffect(function () {
    window.requestAnimationFrame(function () {
      if (element.current) {
        element.current.style.transform = "translate(calc(-50% + ".concat(spreadX, "px), calc(-50% + ").concat(spreadY, "px))");
        element.current.style.fontSize = "".concat((index + 1) / FONT_SCALE, "em");
        element.current.style.opacity = '0';
      }
    });
  }, [index, spreadX, spreadY]);
  return /*#__PURE__*/_jsx(HeartRoot, {
    ref: element,
    children: /*#__PURE__*/_jsx(HeartFilled, {
      fontSize: "inherit"
    })
  });
};
//# sourceMappingURL=Heart.js.map